// Señal simple para recargar el inventario SOLO cuando algo cambió (crear,
// editar o borrar un producto). Así, al abrir un producto y volver, el listado
// NO se recarga y conserva exactamente la posición, el scroll, el filtro y la
// búsqueda del usuario (antes volvía siempre al inicio / a la "A").

let dirty = false;

export const markInventoryDirty = () => { dirty = true; };

// Devuelve true una sola vez si el inventario fue marcado como modificado.
export const consumeInventoryDirty = () => {
  const d = dirty;
  dirty = false;
  return d;
};
